<template>
  <div v-if="remainingSeconds > 0" class="inline-flip-clock">
    <div class="flip-clock-row">
      <div class="flip-unit">
        <div class="flip-card">
          
          <div class="flip-bottom">{{ formattedDays }}</div>
          <div class="flip-animate" v-if="daysChanged">{{ previousDays }}</div>
        </div>
        <span class="flip-label">GÜN</span>
      </div>
      
      <span class="flip-separator">:</span>
      
      <div class="flip-unit">
        <div class="flip-card">
         
          <div class="flip-bottom">{{ formattedHours }}</div>
          <div class="flip-animate" v-if="hoursChanged">{{ previousHours }}</div>
        </div>
        <span class="flip-label">SAAT</span>
      </div>
      
      <span class="flip-separator">:</span>
      
      <div class="flip-unit">
        <div class="flip-card">
          <div class="flip-bottom">{{ formattedMinutes }}</div>
          <div class="flip-animate" v-if="minutesChanged">{{ previousMinutes }}</div>
        </div>
        <span class="flip-label">DAK</span>
      </div>
      
      <span class="flip-separator">:</span>
      
      <div class="flip-unit">
        <div class="flip-card">
          <div class="flip-bottom">{{ formattedSeconds }}</div>
          <div class="flip-animate" v-if="secondsChanged">{{ previousSeconds }}</div>
        </div>
        <span class="flip-label">SAN</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    targetTime: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      remainingSeconds: 0,
      interval: null,
      previousDays: '00',
      previousHours: '00',
      previousMinutes: '00',
      previousSeconds: '00',
      daysChanged: false,
      hoursChanged: false,
      minutesChanged: false,
      secondsChanged: false
    };
  },
  computed: {
    formattedDays() {
      const days = Math.floor(this.remainingSeconds / 86400);
      return String(days).padStart(2, '0');
    },
    formattedHours() {
      const hours = Math.floor((this.remainingSeconds % 86400) / 3600);
      return String(hours).padStart(2, '0');
    },
    formattedMinutes() {
      const minutes = Math.floor((this.remainingSeconds % 3600) / 60);
      return String(minutes).padStart(2, '0');
    },
    formattedSeconds() {
      const seconds = this.remainingSeconds % 60;
      return String(seconds).padStart(2, '0');
    }
  },
  watch: {
    formattedDays(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.previousDays = oldVal;
        this.daysChanged = true;
        setTimeout(() => this.daysChanged = false, 600);
      }
    },
    formattedHours(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.previousHours = oldVal;
        this.hoursChanged = true;
        setTimeout(() => this.hoursChanged = false, 600);
      }
    },
    formattedMinutes(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.previousMinutes = oldVal;
        this.minutesChanged = true;
        setTimeout(() => this.minutesChanged = false, 600);
      }
    },
    formattedSeconds(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.previousSeconds = oldVal;
        this.secondsChanged = true;
        setTimeout(() => this.secondsChanged = false, 600);
      }
    }
  },
  mounted() {
    this.updateRemaining();
    this.interval = setInterval(this.updateRemaining, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    updateRemaining() {
      const now = new Date().getTime();
      const target = new Date(this.targetTime).getTime();
      const diff = Math.max(0, Math.floor((target - now) / 1000));
      this.remainingSeconds = diff;
    }
  }
};
</script>

<style scoped>
.inline-flip-clock {
 
}

.flip-clock-row {
  display: flex;
  align-items: center;

}

.flip-unit {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.flip-card {
  position: relative;
  width: 28px;
  height: 36px;
  perspective: 500px;
}

.flip-top,
.flip-bottom,
.flip-animate {
  position: absolute;
  width: 100%;
  height: 18px;
  overflow: hidden;
   
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
 
   
}

.flip-top {
  top: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  background: linear-gradient(to bottom, #1a2a3a 0%, #0f172a 100%);
  z-index: 2;
  transform-origin: bottom;
}

.flip-bottom {
  bottom: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  background: var(--active-button);
  z-index: 1;
}

.flip-animate {
  top: 0;
  background: linear-gradient(to bottom, #1a2a3a 0%, #0f172a 100%);
  z-index: 3;
  transform-origin: bottom;
  animation: flip 0.6s ease-in-out;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}

.flip-label {
  margin-top: 3px;
  font-size: 10px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
}

.flip-separator {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  
  text-shadow: 0 0 5px rgba(0, 255, 194, 0.5);
}

@keyframes flip {
  0% {
    transform: rotateX(0deg);
  }
  50% {
    transform: rotateX(-90deg);
  }
  100% {
    transform: rotateX(-180deg);
  }
}

/* Daha da kompakt versiyon */
@media (max-width: 480px) {
  .flip-card {
    width: 20px;
    height: 30px;
  }
  
  .flip-top,
  .flip-bottom,
  .flip-animate {
    height: 20px;
    font-size: 16px;
  }
  
  .flip-separator {
    font-size: 16px;
    margin-bottom: 8px;
  }
  
  .flip-label {
    font-size: 8px;
  }
}
</style>